module.exports = __webpack_public_path__ + "static/img/doctorImg.8cb6c65.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/onlineServicesProject/images/doctorImg.png
// module id = 659e
// module chunks = 7